var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoTiempo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono-5@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0976666895%",
    y1: "90.159082%",
    x2: "85.7026624%",
    y2: "21.3553526%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.9756503%",
    y1: "158.798641%",
    x2: "84.3373718%",
    y2: "-2.79073856%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.7066882%",
    y1: "79.9820802%",
    x2: "187.251136%",
    y2: "-60.2602755%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-67.4371859%",
    y1: "144.188377%",
    x2: "765.125628%",
    y2: "-522.645291%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-38.9507345%",
    y1: "155.203056%",
    x2: "325.67921%",
    y2: "-309.289543%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-297.467551%",
    y1: "461.376673%",
    x2: "754.394752%",
    y2: "-811.281071%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols-DIC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elementos-/-icono-5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icono-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2097427,28.0994945 C74.3095157,9.19666685 55.4776571,-2.54860471 35.9128324,0.471884767 C16.3480077,3.49237424 1.93229752,20.3705275 2.00373017,40.1732259 C1.98617319,40.6428765 2.03064786,41.1127913 2.13600249,41.5708016 C2.51843022,42.9017966 3.82467109,43.7458289 5.19480002,43.5472549 C6.5698015,43.3161711 7.57454605,42.1219966 7.56743486,40.7272944 C7.60876997,40.0822594 7.65010507,39.4454941 7.68317315,38.8004591 C7.74081954,36.9680979 7.92311553,35.1417887 8.22879649,33.3342013 C11.7547933,15.018392 29.2622068,2.8753293 47.6459495,5.99464249 C63.8493094,8.63267009 76.4647825,22.8895967 76.4730495,38.4365933 C76.4730495,46.1522038 74.9932528,51.9492488 71.81045,57.250113 C65.9160645,67.066222 57.2356931,72.7557612 45.9346763,74.2443034 C44.7098877,74.3750023 43.4793031,74.4440035 42.2475852,74.4510454 L41.329946,74.4510454 C39.8298601,74.431006 38.5849144,75.6060993 38.5179074,77.1053037 C38.4509004,78.6045082 39.5860469,79.8860481 41.0819354,80 C41.4043492,80 41.73503,80 42.0657108,80 L42.1070459,80 C54.7997,79.9515499 66.7178663,73.8867301 74.2308897,63.6530787 C81.7439132,53.4194273 83.9621086,40.2288039 80.2097427,28.0994945 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6969237,29.0161804 C44.6969237,31.8121913 44.6969237,34.6242253 44.6969237,37.3881902 C44.6629986,37.8663302 44.8932297,38.3254395 45.2995564,38.5899141 C48.8094844,41.2337067 52.3112688,43.8855108 55.7804784,46.6014068 C56.3035441,47.0184176 56.6936597,47.574625 56.9043069,48.2037054 C57.1980572,49.1274704 56.7981024,50.1277988 55.9433521,50.6071532 C55.1010506,51.1671228 53.9868792,51.1249656 53.1907867,50.5030038 C51.5620498,49.3092914 49.9903187,48.099556 48.3941565,46.8657861 C45.9510511,45.0151313 43.5079457,43.1484535 41.0648404,41.3058102 C40.3665927,40.8223982 39.9673964,40.021861 40.0061614,39.1827646 C40.0061614,32.9257888 40.0061614,26.6768245 40.0061614,20.4198487 C39.9257307,19.3479637 40.6404409,18.3744285 41.7000478,18.1125388 C42.6375474,17.8018515 43.6702229,18.1503522 44.2164463,18.9617571 C44.5115656,19.4698148 44.6712487,20.0430593 44.6806363,20.6281475 C44.7213548,23.43217 44.6969237,26.2281809 44.6969237,29.0161804 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5413564,43.0000434 C11.6492474,42.9834607 4.52530483,47.7256314 1.49513341,55.0128549 C-1.53503801,62.3000783 0.126131748,70.6952656 5.70317404,76.2793683 C11.2802163,81.8634711 19.6733013,83.5352671 26.9643619,80.5143271 C34.2554226,77.4933871 39.0066133,70.3754607 38.9999862,62.4833441 C38.9774361,51.7420048 30.2826683,43.0362295 19.5413564,43.0000434 Z M19.935788,77.5539024 C11.8581587,77.9565509 4.86521609,71.3826977 4.4543499,62.9928177 C4.25732674,56.9024831 7.7512228,51.2940387 13.304717,48.786101 C18.8582113,46.2781633 25.3758697,47.3654262 29.8145585,51.5402402 C34.2532473,55.7150541 35.7374294,62.1539316 33.5741311,67.8505221 C31.4108328,73.5471126 26.0267677,77.3777561 19.935788,77.5539024 L19.935788,77.5539024 Z",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    points: "17 65.2104208 14.2743719 65.2104208 14.2743719 68 11.7256281 68 11.7256281 65.2104208 9 65.2104208 9 62.8056112 11.7256281 62.8056112 11.7256281 60 14.2743719 60 14.2743719 62.8056112 17 62.8056112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3524609,60.4536598 L21.4877939,60.4536598 L21.4877939,62.7482086 C21.7292722,62.4853338 22.0247705,62.2847534 22.3513911,62.16201 C23.4003369,61.7602794 24.5647821,61.8802807 25.5205553,62.4886064 C26.0163795,62.8450213 26.4042923,63.3451772 26.6376857,63.92898 C26.8786723,64.533002 27,65.182809 26.9942166,65.8383126 C27.0513508,66.9552154 26.6833148,68.04985 25.9721612,68.878171 C25.2035722,69.6591135 24.1601402,70.063197 23.0961447,69.9919483 C22.3582608,70.0128151 21.625116,69.8612643 20.949036,69.5481123 C20.3761313,69.2785919 19.8871675,68.8430701 19.5387579,68.2919724 C19.2025695,67.7417778 19.0161735,67.1043773 19,66.449634 L21.5828688,66.449634 C21.636059,66.7760305 21.7958692,67.0723715 22.0344747,67.2870605 C22.3065258,67.5269205 22.6554993,67.646873 23.0089927,67.6220312 C23.4216447,67.655758 23.8238894,67.4744398 24.0865085,67.1363238 C24.341257,66.7526172 24.4668034,66.2896468 24.4430395,65.8215641 C24.4732678,65.3784408 24.33979,64.9401867 24.0706627,64.5989213 C23.7864081,64.2992419 23.3937401,64.1436028 22.9931469,64.1718337 C22.6829228,64.1596725 22.3772684,64.2536557 22.1216267,64.4398102 C21.9016752,64.6170681 21.7452307,64.8680561 21.6779437,65.1516228 L19.087152,65.1516228 L19.087152,58 L26.3524609,58 L26.3524609,60.4536598 Z",
    id: "Path",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-6)",
    points: "29.6839729 58 32 58 30.51693 62 29 62"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoTiempo);
export default __webpack_public_path__ + "static/media/icono-tiempo.82c004ff4f8fc3d42a2d0b070b85b99b.svg";
export { ForwardRef as ReactComponent };